import styled from 'styled-components';
import { ReactComponent as CloudAgentIcon } from 'Images/cloud_agent.svg';

export const AgentIcon = styled(CloudAgentIcon)`
  cursor: default;
  margin-top: 10px;
  path {
    stroke: ${({ theme }) => theme.text.tab};
  }
`;
AgentIcon.displayName = 'AgentIcon';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
Wrapper.displayName = 'Wrapper';

export const DataContainer = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  gap: 13px;
`;
DataContainer.displayName = 'DataContainer';
